// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── CausaDetalle — shared detail shell (Concepto B): PageHead (kicker →
   title + actions → sub → meta band) → .dnav tabs → .dbody .cb-cols (aside
   "Datos de la causa" left, tab panels right). The shell geometry (.dnav,
   .dbody/.cb-cols/.cb-aside/.cb-fichahead, .dd-info rows, .dd-iconbtn) lives
   in styles/detail.css; shared atoms (.page, .page-head/.page-title,
   .tabs/.tab, .tbl, StagePill, Empty) come from the design system. Only the
   causa-specific pieces live here. ── */

/* .cd-page's min-height lives with .dd-page's in styles/detail.css. */

/* Spin for the head's sync icon (.dd-iconbtn) while a re-scrape is in
   flight — causa-only behavior, so it stays page-scoped. */
svg.cd-sync-spin {
  transform-origin: 50% 50%;
  animation: cd-sync-spin 0.7s linear infinite;
}

@keyframes cd-sync-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  svg.cd-sync-spin {
    animation: none;
  }
}

/* ── Body: right column of the shared .cb-cols grid ───────────────────── */
.cd-main {
  min-width: 0;
}

/* The aside head reuses the section eyebrow; .cb-fichahead owns the gap. */
.cb-fichahead .cd-colhead {
  margin: 0;
}

/* Section eyebrow, shared by the Resumen panel and the aside head. */
.cd-colhead {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin: 0 0 10px;
}

.cd-k {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
}

/* ── Resumen panel ─────────────────────────────────────────────────────── */
.cd-panel {
  padding-top: 0;
}

/* active-diligencia card */
.cd-dilcard {
  border: 1px solid var(--accent);
  background: var(--accent-soft);
  padding: 15px 17px;
  cursor: pointer;
  transition: border-color var(--dur-1) var(--ease);
}

.cd-dilcard:hover {
  border-color: var(--accent-deep);
}

.cd-dilcard:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.cd-dilcard__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cd-dilcard__cta {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  letter-spacing: 0.06em;
  color: var(--accent-deep);
  white-space: nowrap;
}

.cd-dilrows {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 32px;
  margin-top: 14px;
}

.cd-dilrows__r {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: var(--fs-note);
}

/* empty state for no active diligencia */
.cd-dilempty {
  border: 1px dashed var(--border);
  background: var(--bg-alt);
  padding: 18px 17px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.cd-dilempty p {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--fs-detail);
}

/* recent actuaciones list */
.cd-recent__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-top: 28px;
}

.cd-recent {
  border-top: 1px solid var(--rule-soft);
}

.cd-recent__row {
  display: flex;
  gap: 16px;
  padding: 12px 2px;
  border-bottom: 1px solid var(--rule-soft);
}

.cd-recent__date {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  color: var(--text-muted);
  flex: none;
  width: 96px;
}

.cd-recent__body {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.cd-empty-note {
  font-size: var(--fs-detail);
  color: var(--text-muted);
  margin: 4px 0 0;
}

.card__link {
  color: var(--accent);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: var(--fs-meta);
}

.card__link:hover {
  text-decoration: underline;
}

/* ── Actuación PDF link: accent icon-button inside the shared .tbl ── */
.cd-iconlink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  padding: 0;
  color: var(--accent);
  cursor: pointer;
}

.cd-iconlink:hover {
  color: var(--ink);
}

.cd-iconlink svg {
  width: 16px;
  height: 16px;
  display: block;
}

/* Active diligencia row in the historial (Diligencias tab). */
.tbl tbody tr.cd-row-active td {
  background: var(--accent-soft);
}

/* NotFound UI uses the shared .detail-notfound (styles/detail.css). */

/* la lectura de actuaciones falló, distinta de la causa sin actuaciones */
.cd-empty-note.is-err {
  color: var(--danger);
}

/* ── Not-found causa notice: warning Alert + list and actions ───── */
.cd-notfound-aviso {
  margin: 0 0 20px;
}

.cd-notfound-aviso__lead {
  margin: 0 0 6px;
}

.cd-notfound-aviso__list {
  margin: 0 0 8px;
  padding-left: 18px;
}

.cd-notfound-aviso__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/causas/CausaDetalleVista.css"],"names":[],"mappings":"AAAA;;;;;;wCAMwC;;AAExC,sEAAsE;;AAEtE;2DAC2D;AAC3D;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,4EAA4E;AAC5E;EACE,YAAY;AACd;;AAEA,2EAA2E;AAC3E;EACE,SAAS;AACX;;AAEA,qEAAqE;AACrE;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,6EAA6E;AAC7E;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,wBAAwB;EACxB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,8BAA8B;AAChC;;AAEA,sEAAsE;;AAEtE,0EAA0E;AAC1E;EACE,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB","sourcesContent":["/* ── CausaDetalle — shared detail shell (Concepto B): PageHead (kicker →\n   title + actions → sub → meta band) → .dnav tabs → .dbody .cb-cols (aside\n   \"Datos de la causa\" left, tab panels right). The shell geometry (.dnav,\n   .dbody/.cb-cols/.cb-aside/.cb-fichahead, .dd-info rows, .dd-iconbtn) lives\n   in styles/detail.css; shared atoms (.page, .page-head/.page-title,\n   .tabs/.tab, .tbl, StagePill, Empty) come from the design system. Only the\n   causa-specific pieces live here. ── */\n\n/* .cd-page's min-height lives with .dd-page's in styles/detail.css. */\n\n/* Spin for the head's sync icon (.dd-iconbtn) while a re-scrape is in\n   flight — causa-only behavior, so it stays page-scoped. */\nsvg.cd-sync-spin {\n  transform-origin: 50% 50%;\n  animation: cd-sync-spin 0.7s linear infinite;\n}\n\n@keyframes cd-sync-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  svg.cd-sync-spin {\n    animation: none;\n  }\n}\n\n/* ── Body: right column of the shared .cb-cols grid ───────────────────── */\n.cd-main {\n  min-width: 0;\n}\n\n/* The aside head reuses the section eyebrow; .cb-fichahead owns the gap. */\n.cb-fichahead .cd-colhead {\n  margin: 0;\n}\n\n/* Section eyebrow, shared by the Resumen panel and the aside head. */\n.cd-colhead {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin: 0 0 10px;\n}\n\n.cd-k {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n/* ── Resumen panel ─────────────────────────────────────────────────────── */\n.cd-panel {\n  padding-top: 0;\n}\n\n/* active-diligencia card */\n.cd-dilcard {\n  border: 1px solid var(--accent);\n  background: var(--accent-soft);\n  padding: 15px 17px;\n  cursor: pointer;\n  transition: border-color var(--dur-1) var(--ease);\n}\n\n.cd-dilcard:hover {\n  border-color: var(--accent-deep);\n}\n\n.cd-dilcard:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n\n.cd-dilcard__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cd-dilcard__cta {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  letter-spacing: 0.06em;\n  color: var(--accent-deep);\n  white-space: nowrap;\n}\n\n.cd-dilrows {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 32px;\n  margin-top: 14px;\n}\n\n.cd-dilrows__r {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: var(--fs-note);\n}\n\n/* empty state for no active diligencia */\n.cd-dilempty {\n  border: 1px dashed var(--border);\n  background: var(--bg-alt);\n  padding: 18px 17px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.cd-dilempty p {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: var(--fs-detail);\n}\n\n/* recent actuaciones list */\n.cd-recent__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 28px;\n}\n\n.cd-recent {\n  border-top: 1px solid var(--rule-soft);\n}\n\n.cd-recent__row {\n  display: flex;\n  gap: 16px;\n  padding: 12px 2px;\n  border-bottom: 1px solid var(--rule-soft);\n}\n\n.cd-recent__date {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  color: var(--text-muted);\n  flex: none;\n  width: 96px;\n}\n\n.cd-recent__body {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.cd-empty-note {\n  font-size: var(--fs-detail);\n  color: var(--text-muted);\n  margin: 4px 0 0;\n}\n\n.card__link {\n  color: var(--accent);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: var(--fs-meta);\n}\n\n.card__link:hover {\n  text-decoration: underline;\n}\n\n/* ── Actuación PDF link: accent icon-button inside the shared .tbl ── */\n.cd-iconlink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  padding: 0;\n  color: var(--accent);\n  cursor: pointer;\n}\n\n.cd-iconlink:hover {\n  color: var(--ink);\n}\n\n.cd-iconlink svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n/* Active diligencia row in the historial (Diligencias tab). */\n.tbl tbody tr.cd-row-active td {\n  background: var(--accent-soft);\n}\n\n/* NotFound UI uses the shared .detail-notfound (styles/detail.css). */\n\n/* la lectura de actuaciones falló, distinta de la causa sin actuaciones */\n.cd-empty-note.is-err {\n  color: var(--danger);\n}\n\n/* ── Not-found causa notice: warning Alert + list and actions ───── */\n.cd-notfound-aviso {\n  margin: 0 0 20px;\n}\n\n.cd-notfound-aviso__lead {\n  margin: 0 0 6px;\n}\n\n.cd-notfound-aviso__list {\n  margin: 0 0 8px;\n  padding-left: 18px;\n}\n\n.cd-notfound-aviso__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
